<template>
  <footer class="footer bg-dark-footer relative text-gray-200 dark:text-gray-200">
    <div class="container">
      <div class="grid grid-cols-12">
        <div class="col-span-12">
          <div class="py-[60px] px-0">
            <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
              <div class="lg:col-span-4 md:col-span-12">
                <a href="#" class="text-[22px] focus:outline-none">
                  <img class="footer--logo mx-auto md:mx-0" src="../assets/images/logoBSD/logo-BSD_white.webp" alt="" />
                </a>
                <p class="mt-6 text-gray-300 text-center md:text-left">L'idéal pour ameliorer l'experience client de votre entreprise.</p>
                <ul class="list-none mt-6">
                  <li class="inline mr-3">
                    <a href="https://bj.linkedin.com/company/celeriteholding" target="_blank" class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 dark:hover:bg-indigo-600"><i class="uil uil-linkedin" title="Linkedin"></i></a>
                  </li>
                  <li class="inline mr-3">
                    <a href="https://www.facebook.com/celeriteholding" target="_blank" class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 dark:hover:bg-indigo-600"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a>
                  </li>

                  <li class="inline">
                    <a href="mailto:contact@celeriteholding.com" class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 dark:hover:bg-indigo-600"><i class="uil uil-envelope align-middle" title="email"></i></a>
                  </li>
                </ul>
                <!--end icon-->
              </div>
              <!--end col-->
              <div class="hidden md:block lg:col-span-2 md:col-span-4">
                <h5 class="tracking-[1px] text-gray-100 font-semibold">NOS PRODUITS</h5>
                <ul class="list-none footer-list mt-6">
                  <li>
                    <a href="page-aboutus.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> QR SURVEY</a>
                  </li>
                  <li class="mt-[10px]">
                    <a href="page-services.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> ELECTRO SURVEY</a>
                  </li>
                  <li class="mt-[10px]">
                    <a href="page-team.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> TOUCH SURVEY</a>
                  </li>
                </ul>
              </div>
              <!--end col-->

              <div class="hidden md:block lg:col-span-3 md:col-span-4">
                <h5 class="tracking-[1px] text-gray-100 font-semibold">NOS SIEGES</h5>
                <ul class="list-none footer-list mt-6">
                  <li>
                    <a href="page-terms.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Bénin</a>
                  </li>
                  <li class="mt-[10px]">
                    <a href="page-privacy.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i>Togo</a>
                  </li>
                  <li class="mt-[10px]">
                    <a href="documentation.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Cote-d'ivoir</a>
                  </li>
                </ul>
              </div>
              <!--end col-->

              <div class="flex w-full justify-around items-center md:hidden mx-auto">
                <div class="w-1/2">
                  <h5 class="tracking-[1px] text-gray-100 font-semibold">NOS PRODUITS</h5>
                  <ul class="list-none footer-list mt-6">
                    <li>
                      <a href="page-aboutus.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> QR SURVEY</a>
                    </li>
                    <li class="mt-[10px]">
                      <a href="page-services.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> ELECTRO SURVEY</a>
                    </li>
                    <li class="mt-[10px]">
                      <a href="page-team.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> TOUCH SURVEY</a>
                    </li>
                  </ul>
                </div>
                <!--end col-->

                <div class="w-1/2 pl-6">
                  <h5 class="tracking-[1px] text-gray-100 font-semibold">NOS SIEGES</h5>
                  <ul class="list-none footer-list mt-6">
                    <li>
                      <a href="page-terms.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Bénin</a>
                    </li>
                    <li class="mt-[10px]">
                      <a href="page-privacy.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i>Togo</a>
                    </li>
                    <li class="mt-[10px]">
                      <a href="documentation.html" class="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i class="uil uil-angle-right-b me-1"></i> Cote-d'ivoir</a>
                    </li>
                  </ul>
                </div>
                <!--end col-->
              </div>

              <div class="lg:col-span-3 md:col-span-4">
                <h5 class="tracking-[1px] text-gray-100 font-semibold">Newsletter</h5>
                <p class="mt-6">Inscrivez-vous et recevez les derniers conseils par e-mail.</p>
                <form>
                  <div class="grid grid-cols-1">
                    <div class="foot-subscribe my-3">
                      <label class="form-label">Laissez nous votre email <span class="text-red-600">*</span></label>
                      <div class="form-icon relative mt-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail w-4 h-4 absolute top-3 left-4">
                          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                          <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        <input type="email" class="form-input bg-gray-800 border border-gray-800 text-gray-100 pl-12 focus:shadow-none" placeholder="Email" name="email" required="" />
                      </div>
                    </div>

                    <button type="submit" id="submitsubscribe" name="send" class="btn bg-bsd-700 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md">Souscrire</button>
                  </div>
                </form>
              </div>
              <!--end col-->
            </div>
            <!--end grid-->
          </div>
          <!--end col-->
        </div>
      </div>
      <!--end grid-->
    </div>
    <!--end container-->

    <div class="py-[30px] px-0 border-t border-slate-800">
      <div class="container text-center">
        <div class="md:text-left text-center">
          <p class="mb-0 text-center">© {{ currentDate }} BSD. Construit par <i class="uil uil-rocket text-red-600"></i> <a href="https://celeriteholding.com/" target="_blank" class="text-reset hover:bg-indigo-700 p-2">CELERITE HOLDING.</a></p>
        </div>
      </div>
      <!--end container-->
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentDate: new Date().getFullYear(),
    };
  },
  mounted() {
    this.cookies();
  },
  methods: {
    cookies() {
      window.axeptioSettings = {
        clientId: "64ac4abfe79e7704119a186c",
        cookiesVersion: "dashboard-fr",
      };

      (function (d, s) {
        var t = d.getElementsByTagName(s)[0],
          e = d.createElement(s);
        e.async = true;
        e.src = "//static.axept.io/sdk.js";
        t.parentNode.insertBefore(e, t);
      })(document, "script");
    },
  },
};
</script>

<style></style>
